type PopupOptions = {
  key?: string;
  layout?: 'default' | 'modal';
  width?: number;
  alignLeft?: boolean;
  hideTitle?: boolean;
  overlay?: boolean;
  emoji?: {
    text: string;
    animation: 'none' | 'wave' | 'tada' | 'heart-beat' | 'spin' | 'flash' | 'bounce' | 'rubber-band' | 'head-shake';
  };
  autoClose?: number;
  showOnce?: boolean;
  doNotShowAfterSubmit?: boolean;
  customFormUrl?: string;
  hiddenFields?: {
    [key: string]: any,
  };
  onOpen?: () => void;
  onClose?: () => void;
  onPageView?: (page: number) => void;
  onSubmit?: (payload: any) => void;
};

// Tally service https://tally.so/
export const TALLY_FEEDBACK_KEY = 'wLVgpv';
export const DOWNLOADS_COUNT_TO_SHOW_FEEDBACK = 1;

export const openFeedbackModal = (options: PopupOptions) => {
  setTimeout(() => {
    // @ts-ignore
    window.Tally.openPopup(TALLY_FEEDBACK_KEY, options);
  }, 1000)
};
